export class ContractsFacade {
    constructor(sdk) {
        this.sdk = sdk;
    }
    async fetch(contractId) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.getDataContract(contractId);
    }
    async fetchWithProof(contractId) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.getDataContractWithProofInfo(contractId);
    }
    async getHistory(query) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.getDataContractHistory(query);
    }
    async getHistoryWithProof(query) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.getDataContractHistoryWithProofInfo(query);
    }
    async getMany(contractIds) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.getDataContracts(contractIds);
    }
    async getManyWithProof(contractIds) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.getDataContractsWithProofInfo(contractIds);
    }
    async publish(options) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.contractPublish(options);
    }
    async update(options) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.contractUpdate(options);
    }
}
